// extracted by mini-css-extract-plugin
export default {"container":"TjY_m","spinner-circle--animation":"pmVQZ","spinner-svg--animation":"ZFI52"};